<template>
  <div>
    <section>
      <ul
        class="news-list"
        v-if="!isEmpty"
        v-infinite-scroll="getMyCollectionList"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="20"
      >
        <li v-for="(item,index) in collectionList" :key="item.Id">
          <router-link :to="{name: 'news-detail',params: {id:item.CollectionId}}">
            <div class="img">
              <img
                :src="item.TitleImagePath ?item.TitleImagePath +'?x-oss-process=image/resize,m_fill,h_150,w_200':defaultImg"
                :onerror="defaultImg"
                alt
              >
            </div>
            <div class="main-content">
              <h5 style="-webkit-box-orient: vertical;">{{item.Title}}</h5>
              <span>{{item.CreateTime}}</span>
            </div>
          </router-link>
          <div class="clear-collect clearfix">
            <button class="btn-clear" @click="cancel(item.Id,index)">取消收藏</button>
          </div>
        </li>
      </ul>
      <div class="status-hint" v-show="pageHint">{{pageHint}}</div>
    </section>
    <empty v-if="isEmpty"></empty>
  </div>
</template>

<script>
import empty from '@/views/statePage/empty.vue'

export default {
  components: {
    empty
  },
  data() {
    return {
      pageHint: '',
      isEmpty: false,
      loading: false,
      params: {
        type: '001',
        pageIndex: 1,
        pageSize: 10
      },
      collectionList: [],
      defaultImg: 'this.src="' + require('@/assets/images/activity-img.png') + '"'
    }
  },
  created() {
    this.getMyCollectionList()
  },
  methods: {
    getMyCollectionList() {
      if (this.totalPage > -1 && this.params.pageIndex > this.totalPage) {
        this.loading = false
      } else {
        this.loading = true
        this.pageHint = '加载中...'
        var _this = this
        this.$fetch('/api/Collection/MyList', this.params).then(result => {
          this.isLoading = false
          this.loading = false
          _this.totalPage = result.PageCount
          if (this.params.pageIndex >= this.totalPage) {
            this.pageHint = '没有更多了'
          } else {
            this.pageHint = '上拉加載更多'
          }

          if (result.Items && result.Items.length > 0) {
            this.collectionList = this.collectionList.concat(result.Items)
            this.isEmpty = false
          } else {
            this.isEmpty = true
            this.pageHint = ''
          }
          this.params.pageIndex++
        })
      }
    },
    cancel(id, index) {
      let _this = this
      this.$dialog.confirm({
        title: '取消收藏',
        mes: '确定要取消此收藏？',
        opts: () => {
          this.$post('/api/Collection/Cancel', {
            ID: id
          })
            .then(result => {
              this.$dialog.toast({
                mes: '取消收藏成功',
                timeout: 1500
              })
              _this.collectionList.splice(index, 1)
              if (_this.collectionList.length == 0) {
                this.isEmpty = true
                this.pageHint = ''
              }
            })
            .catch(result => {
              this.$dialog.toast({
                mes: result.Error.Message,
                timeout: 1500
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#success {
  background: #f7f7f7 !important;
}

section {
  width: 100%;

  .news-list {
    padding-top: 25 / @rem-size;
    background: #fff;
    border-bottom: 20 / @rem-size solid #f7f7f7;

    li {
      padding: 0 24 / @rem-size;
      border-bottom: 20 / @rem-size solid #f7f7f7;
      position: relative;
      margin-top: 25 / @rem-size;

      &:first-child {
        margin-top: 0;
      }

      .label {
        width: 80 / @rem-size;
        height: 40 / @rem-size;
        font-size: 24 / @rem-size;
        text-align: center;
        line-height: 40 / @rem-size;
        position: absolute;
        top: 16 / @rem-size;
        left: 0;
        margin: auto;
      }

      &:last-child {
        border: none;
      }

      a {
        display: flex;
        padding-bottom: 20 / @rem-size;
        border-bottom: 1px solid #e5e5e5;
      }

      .img {
        width: 200 / @rem-size;
        height: 132 / @rem-size;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .main-content {
        flex: 1;
        margin-left: 22 / @rem-size;

        h5 {
          font-size: 0.3rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          max-width: 4.9rem;
          font-weight: 500;
          line-height: 46 / @rem-size;
          max-height: 92 / @rem-size;
        }

        span {
          display: block;
          margin-top: 10 / @rem-size;
          color: #999;
          font-size: 28 / @rem-size;
        }
      }
    }
  }
}

.clear-collect {
  padding: 22 / @rem-size 0;

  .btn-clear {
    width: 180 / @rem-size;
    height: 64 / @rem-size;
    border: 1px solid #e5e5e5;
    border-radius: 8 / @rem-size;
    float: right;

    &:active {
      background: #fff - 10%;
    }
  }
}
</style>
